import React from 'react'
import Spacer from '../spacer'

const Large = () => {
    return <Spacer padding={24} />
}

export default Large